let skin;
// if (process.env.APP_TYPE === 'site') {
//   skin = {
//     navTheme: 'dark',
//     primaryColor: '#FA541C',
//     linkColor: '#FA541C',
//     layout: 'sidemenu',
//     contentWidth: 'Fluid',
//     fixedHeader: false,
//     autoHideHeader: false,
//     fixSiderbar: true,
//   };
// } else
if (process.env.APP_TYPE === 'frontsite' || process.env.APP_TYPE === 'site') {
  skin = {
    primaryColor: '#A58877',
    linkColor: '#A58877',
    navTheme: 'dark',
    layout: 'sidemenu',
    contentWidth: 'Fluid',
    fixedHeader: true,
    autoHideHeader: false,
    fixSiderbar: true,
    collapse: true,
  };
} else {
  skin = {
    navTheme: 'dark',
    primaryColor: '#A58877',
    layout: 'sidemenu',
    contentWidth: 'Fluid',
    fixedHeader: true,
    autoHideHeader: false,
    fixSiderbar: true,
  };
}
module.exports = skin;
